import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
import { reviews } from '../mock';

const Reviews = () => {
  return (
    <section
      id="reviews"
      className="py-24 lg:py-32 bg-gradient-to-b from-[#f4ead4] via-[#ecdcbf] to-[#f4ead4]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 mb-14">
          <div className="flex items-center gap-5">
            <div className="bg-[#2a1a0f] text-[#f4ead4] rounded-2xl w-20 h-20 flex flex-col items-center justify-center flex-shrink-0">
              <span className="font-serif text-[24px] leading-none">4.7</span>
              <span className="text-[10px] mt-1 text-[#c9b394]">183 reviews</span>
            </div>
            <div className="lg:hidden text-[12px] tracking-[0.16em] font-medium text-[#b8532a] uppercase">
              From the neighbourhood
            </div>
          </div>
          <div className="flex-1">
            <div className="hidden lg:block text-[12px] tracking-[0.16em] font-medium text-[#b8532a] uppercase mb-3">
              From the neighbourhood
            </div>
            <h2 className="font-serif text-[40px] sm:text-[52px] lg:text-[60px] leading-[1.05] text-[#2a1a0f] tracking-tight">
              People keep coming back for the corner.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <div
              key={i}
              className="bg-[#f4ead4] border border-[#2a1a0f]/10 rounded-2xl p-7 flex flex-col hover:shadow-md transition-shadow"
            >
              <div className="flex gap-0.5 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#c88a3a] text-[#c88a3a]" />
                ))}
              </div>
              <p className="font-serif text-[20px] leading-[1.4] text-[#2a1a0f] flex-1">
                “{r.text}”
              </p>
              <div className="mt-6 pt-5 border-t border-[#2a1a0f]/10 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-[#c88a3a]/25 flex items-center justify-center">
                  <span className="text-[14px] text-[#2a1a0f]">{r.initial}</span>
                </div>
                <div>
                  <div className="text-[14px] text-[#2a1a0f]">{r.name}</div>
                  <div className="text-[12px] text-[#7a5c40]">{r.source}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center gap-3 flex-wrap justify-center">
          <a
            href="https://www.google.com/search?q=bliss+coffee+quesnel+reviews"
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-3 bg-[#2a1a0f] hover:bg-[#3d2817] text-[#f4ead4] px-6 py-3.5 rounded-full transition-colors"
          >
            <span className="text-[15px]">Read Google reviews</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
          </a>
          <a
            href="https://www.google.com/search?q=bliss+coffee+quesnel+write+review"
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-3 bg-[#f4ead4]/60 hover:bg-[#f4ead4] border border-[#2a1a0f]/15 text-[#2a1a0f] px-6 py-3.5 rounded-full transition-colors"
          >
            <span className="text-[15px]">Write a review</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
